import React, { memo } from 'react';
import { lowercaseMixedMutations } from './mixedMutations';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import ListSubTitle from './ListSubTitle';
import ListParagraph from './ListParagraph';

const ExplanationMixedMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseMixedMutations} mutationType={mutationTypes.MIXED}>
      <ul>
        <li>
          <ListSubTitle>e</ListSubTitle>
          <ListParagraph>
            Bremañ e c'hortozan.<br />
            Gant piv e weladennont ar vro?<br />
            Er-maez e vutunomp.<br />
            Mat e vefe dit ma 'z afen ganit? (Cela te dirait si j'y allais avec toi?)<br />
            Ur mennozh mat e vefe.<br />
            Ret e vefe dit diskuizhañ. (Il faudrait que tu te reposes.)<br />
            Poent e vefe dezho dihuniñ. (Il serait temps qu'ils se réveillent.)<br />
            Mat e vefe dit chom er gêr. (Il serait bon que tu restes chez toi.)<br />
            Gwelloc'h e vefe deoc'h chom. (Il vaudrait mieux que vous restiez.)<br />
            Gwelloc'h / Gwell e vefe ganin prenañ ur gitar. (Je préférerais acheter une guitare.)<br />
            Dleet e vefe lakaat anezhañ e prizon. (On devrait le mettre en prison.)<br />
            Dleet e vefe din lavaret ar wirionez. (Je devrais dire la vérité.)<br />
            Dleet e vefe deoc'h bezañ lavaret din abretoc'h. (Vous auriez dû me le dire plus tôt)<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>peogwir e...</ListSubTitle>
          <ListParagraph>
            Peogwir e c'houlennit.<br />
            Peogwir e teu bemdez.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>o</ListSubTitle>
          <ListParagraph>
            O c'hortoz an tren emaomp.<br />
            O vont d'ar gêr emaout.<br />
            O tañsal al lambada emaint.<br />
            Piv zo o vont da zañsal ganin?<br />
            O vont da gousket emaon.<br />
            Mammig zo o vont da labourat.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>ma</ListSubTitle>
          <ListParagraph>
            Ma vefen kanerez e c'hallfen beajiñ.<br />
            Ma vefe rinkined e vefe dañjerus. (S'il y avait des requins, ce serait dangereux.)<br />
            Ma teufe e vefe un dra vat. (S'il venait, ce serait une bonne chose.)<br />
          </ListParagraph>
        </li>
      </ul>
    </ExplanationMutation>
  );
};

export default memo(ExplanationMixedMutation);
